import React from 'react';
import FeatureAccessGuard from './FeatureAccessGuard';
import { FEATURE_NAMES } from '../../apis/featureLimits';
import CreatePoll from '../createpoll';
import { FloatingUsageIndicator } from './FeatureUsageIndicator';

// Wrapper component that adds feature limiting to Polls
const PollsWithLimits = () => {
  return (
    <FeatureAccessGuard 
      featureName={FEATURE_NAMES.POLLS}
      customMessage="Polls are not available for free users. Upgrade to create and share polls."
    >
      <FloatingUsageIndicator 
        featureName={FEATURE_NAMES.POLLS} 
        position="top-right" 
      />
      <CreatePoll />
    </FeatureAccessGuard>
  );
};

export default PollsWithLimits;
